/**
 * @generated SignedSource<<ba84c376af4d5cd836fda76a16777fd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "formId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "formId",
    "variableName": "formId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formTitle",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formSubtitle",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v11 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "partnerId",
        "variableName": "accountId"
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stage",
  "storageKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "Q_ORDER_ASC"
  }
],
v15 = {
  "alias": "key",
  "args": null,
  "kind": "ScalarField",
  "name": "qKey",
  "storageKey": null
},
v16 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "qName",
  "storageKey": null
},
v17 = {
  "alias": "type",
  "args": null,
  "kind": "ScalarField",
  "name": "qType",
  "storageKey": null
},
v18 = {
  "alias": "default",
  "args": null,
  "kind": "ScalarField",
  "name": "qDefault",
  "storageKey": null
},
v19 = {
  "alias": "optional",
  "args": null,
  "kind": "ScalarField",
  "name": "qOptional",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qWidth",
  "storageKey": null
},
v21 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "DISPLAY_ORDER_ASC"
  }
],
v22 = {
  "alias": "value",
  "args": null,
  "kind": "ScalarField",
  "name": "displayOrder",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v24 = [
  {
    "fields": (v2/*: any*/),
    "kind": "ObjectValue",
    "name": "condition"
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qKey",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qResponse",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorProgramFormQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "FormT",
        "kind": "LinkedField",
        "name": "formTByFormId",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VppTsConnection",
            "kind": "LinkedField",
            "name": "vppTsByFormId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VppT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": "VppRtsConnection",
                    "kind": "LinkedField",
                    "name": "vppRTsByVppId",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VppRT",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v14/*: any*/),
            "concreteType": "FormDetailTsConnection",
            "kind": "LinkedField",
            "name": "formDetailTsByFormId",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormDetailT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": (v21/*: any*/),
                    "concreteType": "FormDetailValuesTsConnection",
                    "kind": "LinkedField",
                    "name": "formDetailValuesTsByFormDetailId",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": "values",
                        "args": null,
                        "concreteType": "FormDetailValuesT",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v22/*: any*/),
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "formDetailValuesTsByFormDetailId(orderBy:\"DISPLAY_ORDER_ASC\")"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "formDetailTsByFormId(orderBy:\"Q_ORDER_ASC\")"
          },
          {
            "alias": null,
            "args": (v24/*: any*/),
            "concreteType": "FormResponseTsConnection",
            "kind": "LinkedField",
            "name": "formResponseTsByFormId",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormResponseT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "VendorProgramFormQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v28/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "FormT",
        "kind": "LinkedField",
        "name": "formTByFormId",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VppTsConnection",
            "kind": "LinkedField",
            "name": "vppTsByFormId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VppT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": "VppRtsConnection",
                    "kind": "LinkedField",
                    "name": "vppRTsByVppId",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VppRT",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v13/*: any*/),
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v28/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v14/*: any*/),
            "concreteType": "FormDetailTsConnection",
            "kind": "LinkedField",
            "name": "formDetailTsByFormId",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormDetailT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": (v21/*: any*/),
                    "concreteType": "FormDetailValuesTsConnection",
                    "kind": "LinkedField",
                    "name": "formDetailValuesTsByFormDetailId",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "alias": "values",
                        "args": null,
                        "concreteType": "FormDetailValuesT",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "formDetailValuesTsByFormDetailId(orderBy:\"DISPLAY_ORDER_ASC\")"
                  },
                  (v28/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "formDetailTsByFormId(orderBy:\"Q_ORDER_ASC\")"
          },
          {
            "alias": null,
            "args": (v24/*: any*/),
            "concreteType": "FormResponseTsConnection",
            "kind": "LinkedField",
            "name": "formResponseTsByFormId",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormResponseT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v28/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "68e7b62e12cb7ce84cdddc0a1bcf75c0",
    "id": null,
    "metadata": {},
    "name": "VendorProgramFormQuery",
    "operationKind": "query",
    "text": "query VendorProgramFormQuery(\n  $formId: UUID!\n  $accountId: UUID!\n) {\n  accountTByAccountId(accountId: $accountId) {\n    accountName\n    nodeId\n  }\n  formTByFormId(formId: $formId) {\n    formName\n    formTitle\n    formSubtitle\n    description\n    vppTsByFormId {\n      nodes {\n        description\n        programName\n        visibility\n        vppRTsByVppId(condition: {partnerId: $accountId}) {\n          totalCount\n          nodes {\n            stage\n            nodeId\n          }\n        }\n        nodeId\n      }\n    }\n    formDetailTsByFormId(orderBy: Q_ORDER_ASC) {\n      totalCount\n      nodes {\n        key: qKey\n        name: qName\n        type: qType\n        default: qDefault\n        optional: qOptional\n        qWidth\n        formDetailValuesTsByFormDetailId(orderBy: DISPLAY_ORDER_ASC) {\n          totalCount\n          values: nodes {\n            value: displayOrder\n            text\n            nodeId\n          }\n        }\n        nodeId\n      }\n    }\n    formResponseTsByFormId(condition: {accountId: $accountId}) {\n      totalCount\n      nodes {\n        accountId\n        qKey\n        qResponse\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "9f67642c76efedf3504592929f2187ad";

module.exports = node;
